import React from 'react';

import { SVGComponentProps } from './svg.types';

const NextMediaSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="14"
        height="16"
        viewBox="0 0 14 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.37903 13.7714C5.37903 15.0022 4.3812 16 3.15045 16C1.91971 16 0.921875 15.0022 0.921875 13.7714V2.22858C0.921875 0.997837 1.91971 0 3.15045 0C4.3812 0 5.37903 0.997837 5.37903 2.22858V13.7714Z"
          fill={fill}
        />
        <path
          d="M13.7423 13.7714C13.7423 15.0022 12.7445 16 11.5137 16C10.283 16 9.28516 15.0022 9.28516 13.7714V2.22858C9.28549 0.997837 10.2833 0 11.5137 0C12.7445 0 13.7423 0.997837 13.7423 2.22858V13.7714Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default NextMediaSVG;
